import { FormControlled, type FormControlledRenderParams, FormField } from "@common/controls/Form/component";
import Icon from "@common/controls/Icon/component";
import TextAreaAutosize from "@common/controls/Inputs/TextArea/AutoSize/component";
import { IconType, SystemColor } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import { type Ai } from "@common/modules/ai/types";
import { last } from "lodash";
import React from "react";
import Messages from "./Messages";

type FormData = {
  input: string;
};

type Props = {
  agentName: string;
  chats?: Ai.Chat.View.Chat[];
  isDisabled: boolean;
  messages: Ai.ChatMessage.View.ChatMessage[];
  onSendMessage: (input: string) => Promise<string | null>;
  welcomeMessage: string;
};
export default (props: Props) => {
  const i18n = useI18n();

  const defaultValues = React.useMemo(
    (): FormData => ({
      input: ""
    }),
    []
  );

  const onSubmit = React.useCallback(
    async (data: FormData) => {
      const input = data.input.trim();
      if (!input) return;

      const lastMessage = last(props.messages);
      if (!!lastMessage && !lastMessage.message) return;

      await props.onSendMessage(input);
    },
    [props.messages, props.onSendMessage]
  );

  return (
    <div className="ai_chat_content">
      <Messages agentName={props.agentName} data={props.messages} welcomeMessage={props.welcomeMessage} />

      <FormControlled className="footer" defaultValues={defaultValues} resetOnSubmit="pre" submit={onSubmit}>
        {({ submit, values }: FormControlledRenderParams<FormData>) => (
          <FormField
            Component={TextAreaAutosize}
            isDisabled={props.isDisabled}
            componentProps={{
              addon: (
                <Icon
                  className="send_message"
                  onClick={submit}
                  color={values.input.trim() ? SystemColor.Blue : SystemColor.Gray}
                  icon={IconType.PaperPlaneTop}
                />
              ),
              className: "message_input",
              enterMode: "shift",
              maxRows: 6,
              onEnter: submit,
              placeholder: i18n.typeAMessage
            }}
            name="input"
            value={values.input}
          />
        )}
      </FormControlled>
    </div>
  );
};
